import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { selectors as globalSelectors } from 'global-reducer'
import { selectors as globalSchoolSelectors } from 'school-portal-reducer'
import * as Types from 'types'
import { LoadingSpinner, Card, RenderedHtml } from 'components'
import ProfileCompletionCard from '../profile-completion-card'
import SurveyCompletionCard from '../survey-completion-card'
// import { format } from 'date-fns'
import { waitFor } from 'lp-hoc'
import { useCommunity, useCommunityText } from 'utils'
import { selectors as surveySelectors } from '../../survey/reducer'
import { get } from 'lodash'
import { ProgramsIcon, SchoolIcon, ArrowRightIcon } from 'components/icons'

const propTypes = {
  school: Types.school.isRequired,
  completionSchool: Types.school,
  isSurveyOpen: PropTypes.bool.isRequired,
  surveySchoolYear: Types.schoolYear,
  currentSchoolYear: Types.schoolYear.isRequired,
  participation: Types.participation,
  surveyQuestions: PropTypes.arrayOf(Types.surveyQuestion),
  surveyAttempt: Types.surveyAttempt,
  definedDisciplines: PropTypes.arrayOf(Types.discipline),
}

const defaultProps = {
  completionSchool: null,
  surveySchoolYear: null,
  participation: null,
  surveyQuestions: null,
  surveyAttempt: null,
  definedDisciplines: null,
}

function Dashboard({
  school,
  completionSchool,
  isSurveyOpen,
  surveySchoolYear,
  currentSchoolYear,
  participation,
  surveyQuestions,
  surveyAttempt,
  definedDisciplines,
}) {
  const { schoolProfileCompletionEnabled, surveyCompletionEnabled = true } =
    useCommunity()
  const t = useCommunityText()
  const surveySchoolYearNumber = get(surveySchoolYear, 'number')
  // Survey completion defaults on; communities can opt out via config.
  const showSurveyCompletion = isSurveyOpen && surveyCompletionEnabled
  return (
    <span>
      <Card>
        <div className="rendered-html">
          <RenderedHtml addAttrs={['target']}>
            {t('schoolPortal.dashboard.welcomeMessage', {
              surveySchoolYearNumber,
            })}
          </RenderedHtml>
        </div>
      </Card>
      {(schoolProfileCompletionEnabled || showSurveyCompletion) && (
        <div className="dashboard-completion-cards">
          {showSurveyCompletion && (
            <SurveyCompletionCard
              school={school}
              participation={participation}
              surveyQuestions={surveyQuestions}
              surveyAttempt={surveyAttempt}
              disciplines={definedDisciplines}
            />
          )}
          {schoolProfileCompletionEnabled && (
            <ProfileCompletionCard school={completionSchool || school} />
          )}
        </div>
      )}
      <div className="to-do-blocks school-dashboard-stats">
        {isSurveyOpen && (
          <Card>
            {/* <div className="highlight">
              <div className="highlight-inner">
                <div className="progress progress--circle progress--15">
                    <div className="progress-block">
                      <span>20%</span>
                      <p>Complete</p>
                    </div>
                </div>
              </div>
            </div> */}

            <div className="value-block">
              <div className="value">
                <ProgramsIcon />
              </div>
            </div>

            <div className="text-block">
              <h3>
                {surveySchoolYearNumber
                  ? `${surveySchoolYearNumber} Survey`
                  : 'Survey'}
              </h3>
              <p id="continue-survey" className="font-small">
                Click below to complete the artlook&reg; Survey! Through this
                brief survey, you'll share information about your school's arts
                education offerings, including staffing, instruction, arts
                courses, and more. Your responses help strengthen arts education
                across the community.
              </p>
              <Link
                to="/school-portal/survey"
                className="button-secondary button-small profile-completion-button"
                aria-describedby="continue-survey"
              >
                Complete
                <ArrowRightIcon />
              </Link>
            </div>
          </Card>
        )}
        <Card>
          {/* <div className="highlight">
            <div className="highlight-inner">
              <div className="date">
                <div className="date-block">
                  <span>{ format(updatedAt, 'MM-DD-YY') }</span>
                  <p>Last Updated</p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="value-block">
            <div className="value">
              <SchoolIcon />
            </div>
          </div>
          <div className="text-block">
            <h3>{currentSchoolYear.number} artlook&reg; Profile</h3>
            <p id="school-updates" className="font-small">
              Click below to complete your artlook&reg; Profile! Share details
              about your partnership and resource interests and needs so arts
              organizations and teaching artists can better connect with and
              support your school.
            </p>
            <Link
              to="/school-portal/summary"
              className="button-secondary button-small profile-completion-button"
              aria-describedby="school-updates"
            >
              Update &amp; Complete
              <ArrowRightIcon />
            </Link>
          </div>
        </Card>
      </div>
    </span>
  )
}

Dashboard.propTypes = propTypes
Dashboard.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    school: globalSchoolSelectors.school(state),
    completionSchool: globalSchoolSelectors.completionSchool(state),
    isSurveyOpen: surveySelectors.isSurveyOpen(state),
    surveySchoolYear: globalSchoolSelectors.surveySchoolYear(state),
    currentSchoolYear: globalSelectors.currentSchoolYear(state),
    participation: globalSchoolSelectors.surveyParticipation(state),
    surveyQuestions: surveySelectors.surveyQuestions(state),
    surveyAttempt: surveySelectors.surveyAttempt(state),
    definedDisciplines: globalSelectors.definedDisciplines(state),
  }
}

export default compose(
  connect(mapStateToProps),
  waitFor('school', LoadingSpinner)
)(Dashboard)
